import { GoalForLinkDto } from '@/modules/flagship/investor-goal/link-sowos-wealth/domain/dtos/goal-for-link-dto';
import { ContributionGoalForLinkDto } from '@/modules/flagship/investor-goal/link-sowos-wealth/domain/dtos/contribution-goal-for-link-dto';

export default class LinkGoalState {
  is_loading = false;

  associated_product_id = '';

  selected_goals: Array<GoalForLinkDto> = [];

  unassigned_balance = 0;

  total_goals_contribution = 0;

  define_contribution_later = false;

  first_goal_contribution: ContributionGoalForLinkDto = {
    id: '',
    amount: 0,
    amount_field: '0',
    collection_day: 0,
    distributions: [],
  }

  second_goal_contribution: ContributionGoalForLinkDto = {
    id: '',
    amount: 0,
    amount_field: '0',
    collection_day: 0,
    distributions: [],
  }

  contribution_limit_reached = false;
}
